import { Particle } from "../particle";
import {
	colorConstant,
	hold,
	lerp,
	linearMotion,
	randomAngle,
	randomBetween,
	randomSign,
	stopAfter,
} from "../interpolation";

export class SolidifyMobBurstParticle extends Particle {
	constructor(originX: number, originY: number) {
		const angle = randomAngle();
		const speed = randomBetween(2.0, 3.5);
		const vx = Math.cos(angle) * speed;
		const vy = Math.sin(angle) * speed;

		const r = randomBetween(120, 170);
		const g = randomBetween(100, 150);
		const b = randomBetween(240, 255);

		super(originX, originY, {
			ttl: randomBetween(400, 550),
			size: lerp(0.5, 0.15),
			opacity: hold(0.8, 0.6, lerp(0.8, 0.0)),
			color: colorConstant(r, g, b),
			rotation: lerp(0, randomSign() * randomBetween(3, 6)),
			position: stopAfter(linearMotion(vx, vy), 0.4),
		});
	}
}
